import { LeadType } from "views/leads-id/types";

const isLeadType = (value: string): value is LeadType =>
  value === LeadType.Owner || value === LeadType.Tenant;

export const getSelectedLeadTypes = (
  leadTypes: string[] | undefined,
  isOwnerLeadsEnabled: boolean,
  applyTenantDefault: boolean
): LeadType[] => {
  if (!isOwnerLeadsEnabled) return [];
  if (leadTypes === undefined)
    return applyTenantDefault ? [LeadType.Tenant] : [];
  return Array.from(new Set(leadTypes.filter(isLeadType)));
};

export const isAnyLeadTypeSelection = (selected: LeadType[]): boolean =>
  selected.length === 0 ||
  (selected.includes(LeadType.Owner) && selected.includes(LeadType.Tenant));

export const isOnlyOwnerSelected = (selected: LeadType[]): boolean =>
  selected.length === 1 && selected[0] === LeadType.Owner;

export const getLeadTypesLabel = (selected: LeadType[]): string => {
  if (isAnyLeadTypeSelection(selected)) return "Any";
  return selected[0] === LeadType.Owner ? "Owner" : "Tenant";
};

export const getLeadTypesParam = (
  selected: LeadType[]
): LeadType[] | undefined => {
  if (isAnyLeadTypeSelection(selected)) return undefined;
  return selected;
};
